import { DbCenterBaseApiV2 } from "../../DbCenterBaseApiV2";

export class ModuleDynamicPageApi extends DbCenterBaseApiV2 {

    public get ControllerName(): any {
        return 'moduleDynamicPage';
    }

}